import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { lazyRoute } from "@/routes/lazy-route";

const ComponentListLayout = lazyRoute(() => import("./component-list/component-list.layout"), "ComponentListLayout");
const ComponentListPage = lazyRoute(() => import("./component-list/component-list.page"), "ComponentListPage");
const DashboardListLayout = lazyRoute(() => import("./dashboard-list/dashboard-list.layout"), "DashboardListLayout");
const DashboardListPage = lazyRoute(() => import("./dashboard-list/dashboard-list.page"), "DashboardListPage");
const DashboardTrashPage = lazyRoute(() => import("./dashboard-list/dashboard-trash.page"), "DashboardTrashPage");
const DashboardDownloadsPage = lazyRoute(() => import("./dashboard-list/dashboard-downloads.page"), "DashboardDownloadsPage");
const ComponentEditorPage = lazyRoute(() => import("./component-editor.page"), "ComponentEditorPage");
const DashboardEditorPage = lazyRoute(() => import("./dashboard-editor.page"), "DashboardEditorPage");

export const publicDashboardRoutes = [
  {
    path: "public-dashboards",
    element: <DashboardListLayout />,
    children: [
      {
        path: "",
        element: <DashboardListPage />,
      },
      {
        path: "trash",
        element: (
          <FeatureFlagToggle flag="enable-fluid-engine">
            <DashboardTrashPage />
          </FeatureFlagToggle>
        ),
      },
      {
        path: "downloads",
        element: <DashboardDownloadsPage />,
      },
    ],
  },
  {
    path: "public-dashboards/components",
    element: (
      <FeatureFlagToggle flag="enable-fluid-engine" isInverted>
        <ComponentListLayout />
      </FeatureFlagToggle>
    ),
    children: [
      {
        path: "",
        element: <ComponentListPage />,
      },
    ],
  },
  {
    path: "public-dashboards/components/:dashboardId/edit",
    element: (
      <FeatureFlagToggle flag="enable-fluid-engine" isInverted>
        <ComponentEditorPage />
      </FeatureFlagToggle>
    ),
  },
  {
    path: "public-dashboards/:dashboardId/edit",
    element: <DashboardEditorPage />,
  },
];
